export default {
  feedback: {
    login_success: 'Successfully logged in',
    logout_success: 'Successfully logged out',
  },
};
